import React from "react";
import PaymentConfirmationContainer from "../containers/payment-confirmation-container";

const PaymentConfirmationPage = () => (
  <main className="payment-confirmation-page">
    <PaymentConfirmationContainer />
  </main>
);

export default PaymentConfirmationPage;
